import type { ConversationThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface FacebookThreadViewProps {
  thread: ConversationThread;
}

export const FacebookThreadView = memo(function FacebookThreadView({
  thread,
}: FacebookThreadViewProps) {
  return <ChatThreadView channel="facebook" thread={thread} />;
});
